/**
 * API Base URL
 * ─────────────────────────────────────────────────────────────────
 * للتحكم في البيئة، غيّر REACT_APP_API_URL في ملف .env.local:
 *
 *   محلي  →  REACT_APP_API_URL=http://backend.goldensection.agency/public/api
 *   سيرفر →  REACT_APP_API_URL=http://backend.goldensection.agency/public/api
 */
export const BASE_URL =
  process.env.REACT_APP_API_URL ||
  "http://backend.goldensection.agency/public/api";

export const API_URL = `${BASE_URL}`;
